import moment from 'moment';
import { getShouldUseAttestation } from '../../../../growthbook';
import { useFetchProfessionalBenevisAttestation } from '../hooks/useFetchProfessionalBenevisAttestation';

export const ProfessionalAttestationLineInfo = ({ userId }) => {
  const { data } = useFetchProfessionalBenevisAttestation(userId);
  const expiredAt = data?.consented_requirements?.[0]?.expired_at;
  const expiredAtFormatted = expiredAt ? moment(expiredAt).format('ddd, MMMM Do, YYYY') : '-'

  if (!getShouldUseAttestation()){
    return null;
  }

  return (
    <div
      style={{
        width: '100%',
        borderBottom: '1px solid #efefef',
        padding: '5px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <p className="card-text" style={{ fontWeight: '600' }}>
        Benevis Attestation:
      </p>
      <p className="card-text">{expiredAtFormatted}</p>
    </div>
  );
};
